import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi';
import { IBankTransaction } from '../types';

/**
 * React Query mutation hook for processing a fully allocated bank transaction.
 * Calls POST /bank-transactions/{uuid}/process endpoint.
 *
 * OWA-10230
 *
 * @returns Mutation object for processing the transaction
 */
export const useProcessBankTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation<IBankTransaction, Error, string>({
    mutationFn: async (transactionUuid: string) => {
      const api = makeBookingManagerApi();
      return api.processBankTransaction(transactionUuid);
    },
    onSuccess: (_data, transactionUuid) => {
      // Invalidate the bank transaction query to refetch fresh data
      queryClient.invalidateQueries({
        queryKey: ['bankTransaction', transactionUuid],
      });
      // Also invalidate the list query in case status changed
      queryClient.invalidateQueries({
        queryKey: ['bankTransactions'],
      });
    },
  });
};
